module.exports = __webpack_public_path__ + "img/Free Chart Image on Unsplash.9437bbd2.png";